import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from "./layout/app.layout.component";
import { LoginComponent } from './components/auth/login/login.component';
import { LoginG } from "./guards/login.g";
import { AuthGuard } from "./service/auth.guard";
import { RegisterComponent } from "./components/auth/register/register.component";

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: AppLayoutComponent,
                children: [
                    { path: '', loadChildren: () => import('./components/all-dashboard/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard] },
                    { path: '', component: LoginComponent, canActivate: [LoginG] },
                    { path: 'dashboard', loadChildren: () => import('./components/all-dashboard/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuard], title: 'PB: Dashboard' },
                    { path: 'users', loadChildren: () => import('./components/masters/users/users.module').then(m => m.UsersModule), canActivate: [AuthGuard], title: 'PB: User' },
                    { path: 'customers', loadChildren: () => import('./components/masters/customers/customers.module').then(m => m.CustomersModule), canActivate: [AuthGuard], title: 'PB: Customer' },
                    { path: 'customers-view', loadChildren: () => import('./components/masters/customers-view/customers-view.module').then(m => m.CustomersViewModule), canActivate: [AuthGuard], title: 'PB: Customer View' },
                ]
            },
            { path: 'auth', loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule) },
            { path: 'login', component: LoginComponent },
            { path: '**', redirectTo: '/dashboard' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
